import { Token } from 'vvs-sdk'
import { mainnetTokens, testnetTokens, getTokens as getConfigTokens, TokenList } from 'vvs-config'
import { serializeToken } from 'state/user/hooks/helpers'
import { SerializedToken } from './types'

export { mainnetTokens, testnetTokens }

interface SerializedTokenList {
  [symbol: string]: SerializedToken
}

// when the token is used in vvs-frontend (e.g `token.vvs`), please make sure that it is included in vvs-config
export const getTokens = (chainId = process.env.REACT_APP_CHAIN_ID): TokenList => {
  return getConfigTokens(chainId)
}

export const tokensByAddress = (): Record<string, Token> => {
  const tokenList = getTokens()
  const tokenListByAddress: Record<string, Token> = Object.keys(tokenList).reduce((accum, key) => {
    return { ...accum, [tokenList[key].address]: tokenList[key] }
  }, {})

  return tokenListByAddress
}

export const serializeTokens = (chainId = process.env.REACT_APP_CHAIN_ID): SerializedTokenList => {
  const unserializedTokens = getTokens(chainId)
  const serializedTokens = Object.keys(unserializedTokens).reduce((accum, key) => {
    return { ...accum, [key]: serializeToken(unserializedTokens[key]) }
  }, {})

  return serializedTokens
}

export const serializeTokensByAddress = (): SerializedTokenList => {
  const unserializedTokens = getTokens()
  const serializedTokens = Object.keys(unserializedTokens).reduce((accum, key) => {
    return { ...accum, [unserializedTokens[key].address]: serializeToken(unserializedTokens[key]) }
  }, {})

  return serializedTokens
}

export default getTokens()
